import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ForgotPassword } from "../services/authService";
import { useNavigate } from "react-router-dom";

const ForgotPasswordComponent = () => {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [loading, setLoading] = useState(false);

  const [isSuccess, setIsSuccess] = useState(false);

  // Email Validation
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email) return "Email is required";
    if (!emailRegex.test(email)) return "Invalid email format";
    return "";
  };

  // Handle Email Change
  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    setEmailError(validateEmail(e.target.value));
  };

  // Handle Form Submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    setEmailError("");

    const error = validateEmail(email);
    if (error) {
      setEmailError(error);
      return;
    }

    setLoading(true);
    try {
      const response = await ForgotPassword({ email });
      console.log("sanket", response);
      if (response.success) {
        // toast.success("Password reset link sent to your email.");
        setIsSuccess(true);
        setEmail("");
      } else {
        toast.error(response.message || "Something went wrong.");
      }
    } catch (err) {
      toast.error("Failed to send reset link. Try again later.");
    }
    setLoading(false);
  };

  return (
    <div className="landing-container mobile-css2">
      <div className="logo-container mobile-css">
        <img src="/images/mainLogo.png" alt="Logo" className="mian-logo" />
      </div>
      <div className="forgotpass1">
        <div
          className="text-center text-white"
          style={{ width: "100%", maxWidth: "500px" }}
        >
          {/* <h2>Forgotten your password?</h2> */}
          <h2 className="forgot-last">
            {isSuccess ? "Password Reset" : "Forgotten your password?"}
          </h2>
        </div>
        <div className="text-center text-white">
          <form onSubmit={handleSubmit}>
            <div className="input-style forgot-style1">
              <label
                className="form-label text-white"
                style={{ fontSize: "16px" }}
              >
                Email
              </label>
              <input
                type="email"
                className="form-control"
                placeholder="Enter it here"
                value={email}
                onChange={handleEmailChange}
                style={{
                  background: "#FFFFFF",
                  color: "black",
                  border: emailError ? "1px solid red" : "0.5px solid white",
                  borderRadius: "0",
                }}
              />
              {emailError && (
                <small className="text-danger">{emailError}</small>
              )}
            </div>
            <button
              className="btn w-100"
              type="submit"
              disabled={loading}
              style={{
                color: "#FD948D",
                border: "1px solid #FD948D",
                borderRadius: "0",
              }}
            >
              {loading ? "Processing..." : "RESET PASSWORD"}
            </button>
          </form>

          {isSuccess && (
            <>
              <h5 className="sent1">Email sent! </h5>
              <p className="sent2">
                If you haven’t received your email, please check your spam
                folder and make sure the email address you entered is the one
                registered to your account.
              </p>

              <button
                className="btn w-100 mb-4"
                onClick={() => navigate("/login")}
                style={{
                  color: "#FD948D",
                  border: "1px solid #FD948D",
                  borderRadius: "0",
                }}
              >
                LOGIN
              </button>
            </>
          )}

          {/* {!isSuccess && (
            <p className="text-white">
              <Link to="/login" className="text-decoration-none text-white">
                Log In
              </Link>
            </p>
          )} */}
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordComponent;
